var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbstractSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 32,
    rx: 6,
    fill: "url(#paint0_linear_4086_107882)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0391 23.7873L24.5465 19.4033H17.4522L12.9596 23.7873L15.0676 25.8444L19.5602 21.4603C19.9453 21.0845 20.4531 20.8795 20.9994 20.8795C21.5456 20.8795 22.0533 21.0845 22.4385 21.4603L26.9311 25.8444L29.0391 23.7873Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2946 18.1386L31.4294 19.7412L32.1998 16.929L26.0649 15.3264C25.5397 15.1898 25.102 14.8618 24.8288 14.4005C24.5557 13.9426 24.4857 13.4061 24.6258 12.8936L26.268 6.90701L23.3862 6.15527L21.7439 12.1418L25.2911 18.1353L25.2946 18.1386Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5705 19.7412L16.7054 18.1386L16.7089 18.1353L20.2561 12.1418L18.6138 6.15527L15.732 6.90701L17.3742 12.8936C17.5143 13.4061 17.4443 13.9426 17.1711 14.4005C16.898 14.8618 16.4603 15.1898 15.9351 15.3264L9.80019 16.929L10.5705 19.7412Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4086_107882",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16CB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C165"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractSymbol);
export default __webpack_public_path__ + "static/media/AbstractSymbol.675dac4a102425d858d45d4a4e0c3c0c.svg";
export { ForwardRef as ReactComponent };